<template>
  <div class="flex flex-col min-h-screen" dir="ltr">
    <DefaultHeader />
    <main class="mb-auto">
      <slot class="my-4" />
    </main>
    <DefaultFooter />
  </div>
</template>
